<template lang="html">
  <div class="body-login">
    <div class="wrapper fadeInDown">
      <div class="fadeIn first">
        <img src="@/assets/macurco-logo.png" class="login-logo" />
      </div>
      <div id="formContent">
        <h4>{{ $t("login.forgotPassword") }}</h4>
        <span>{{ $t("login.usernameSendInstructions") }}</span>
        <form @submit="onSubmit($event)">
          <input type="text" v-model="email" />
          <button class="btn btn-primary w-50 mt-3 mb-1" :disabled="loading">
            <span class="spinner-border spinner-border-sm" v-show="loading" />
            {{ $t("button.send") }}
          </button>
        </form>
        <router-link style="margin-top: 10px" to="/login">
          {{ $t("button.goBack") }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { requesToken } from "@/api/index";

export default {
  name: "Forgot",
  data() {
    return {
      email: "",
      loading: false,
    };
  },
  methods: {
    onSubmit(e) {
      e.preventDefault();
      this.loading = true;
      requesToken({ username: this.email })
        .then((res) => {
          console.warn(res);
          this.loading = false;
          this.$router.push("/email-sended");
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./login.scss";
</style>
